const RetroContent = {
	meta: "Retrospective",
	title: "Looking back, what would I have done differently?",
	paras: [
		"The UX of search was the first problem I addressed when I joined this new front-end team. Some of our greatest gains were made at this part of the user journey.",
		"The core strategy was focused on regular releases of new designs for validation; incrementally improving the UX and business outcomes. However, there was ample opportunity to run a dual track which explored more innovative solutions. I could have taken ownership of this by conducting ideation and design thinking sessions with the team on a more regular basis.",
	],
};

export default RetroContent;
